var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container capacityDetail" },
    [
      _c(
        "div",
        { staticClass: "searchBox_top" },
        [
          _vm.emplFlag == "SUP" && _vm.status == "new"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveDetail()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.saveDraft")))]
              )
            : _vm._e(),
          _vm.emplFlag == "SUP" && _vm.status == "new"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitDetail()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.submit")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.historyBack } },
            [_vm._v(_vm._s(_vm.$t("common.close")))]
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card", staticStyle: { "margin-top": "40px" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("capacity.DetailedInvestigation"))),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "searchBox_bottom" },
            [
              _vm.emplFlag == "SUP" && _vm.status == "new"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.addDetail },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.add")))]
                  )
                : _vm._e(),
              _vm.emplFlag == "SUP" && _vm.status == "new"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "mini" },
                      on: { click: _vm.delDetatil },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.del")))]
                  )
                : _vm._e(),
              _vm.emplFlag == "SUP" && _vm.status == "new"
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.templateDownload },
                    },
                    [_vm._v(_vm._s(_vm.$t("capacity.downloadWrite")))]
                  )
                : _vm._e(),
              _vm.emplFlag != "SUP" && _vm.capacityDetail.status == "completed"
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.dowloadAllSupZip },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.bulkDownload")))]
                  )
                : _vm._e(),
              _vm.emplFlag == "SUP" && _vm.status == "new"
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      attrs: {
                        action: "upload",
                        "http-request": _vm.templateUpload,
                        "show-file-list": false,
                        multiple: "",
                        name: "file",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "mini",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v(_vm._s(_vm.$t("common.upload")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            [
              !_vm.isSupplier
                ? _c(
                    "el-table",
                    {
                      staticClass: "table",
                      attrs: {
                        data: _vm.supplierCapacityList,
                        border: "",
                        "highlight-current-row": "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          "min-width": "120",
                          prop: "supplierCode",
                          label: _vm.$t("capacity.supplierCode"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          "min-width": "120",
                          prop: "supplierNameShort",
                          label: _vm.$t("capacity.supplierNameShort"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          "min-width": "120",
                          prop: "updateDate",
                          label: _vm.$t("capacity.updateDate1"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          "min-width": "120",
                          prop: "statusI18n",
                          label: _vm.$t("capacity.statusI18n"),
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          "show-overflow-tooltip": "",
                          "min-width": "250",
                          prop: "",
                          label: _vm.$t("capacity.attachmentDownload"),
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.status == "completed"
                                  ? _vm._l(
                                      scope.row.supDoc,
                                      function (item, index) {
                                        return _c(
                                          "el-link",
                                          {
                                            key: index,
                                            attrs: { type: "primary" },
                                            nativeOn: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.downloadFile(item)
                                              },
                                            },
                                          },
                                          [_vm._v(_vm._s(item.documentName))]
                                        )
                                      }
                                    )
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "searchBox_bottom" },
            [
              _vm.emplFlag != "SUP" && _vm.capacityDetail.status == "completed"
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "10px" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.templateDownload },
                    },
                    [_vm._v(_vm._s(_vm.$t("common.download")))]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "formcapacityList",
              attrs: {
                model: _vm.formcapacityList,
                rules: _vm.rulescapacityList,
              },
            },
            [
              _c(
                "el-table",
                {
                  ref: "capacityList",
                  attrs: {
                    data: _vm.formcapacityList.capacityList,
                    border: "",
                    "highlight-current-row": "",
                    "max-height": "420",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55", align: "center" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: _vm.$t("supplierManage.Category1"),
                      prop: "categoryName1",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      label: _vm.$t("supplierManage.Category2"),
                      prop: "categoryName2",
                      align: "center",
                    },
                  }),
                  _vm._l(_vm.tableColumnList, function (val, index) {
                    return _c("el-table-column", {
                      key: index,
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: val.key,
                        label: val.title,
                        "min-width": "200",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                val.title.indexOf("利用率") != -1
                                  ? _c(
                                      "el-form-item",
                                      {
                                        class: _vm.changeBackgroung(
                                          val.title,
                                          scope.row[val.key]
                                        ),
                                        attrs: {
                                          prop:
                                            "capacityList." +
                                            scope.$index +
                                            "." +
                                            val.key,
                                          rules: [
                                            {
                                              required: true,
                                              message:
                                                _vm.$t("visitPlan.noEmpty"),
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c(
                                          "el-input",
                                          {
                                            attrs: {
                                              disabled:
                                                index == 0 ||
                                                _vm.status != "new",
                                              oninput:
                                                "value=value.replace(/[^\\d.]/g,'')",
                                            },
                                            model: {
                                              value: scope.row[val.key],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  scope.row,
                                                  val.key,
                                                  $$v
                                                )
                                              },
                                              expression: "scope.row[val.key]",
                                            },
                                          },
                                          [
                                            _c("template", { slot: "append" }, [
                                              _vm._v("%"),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "capacityList." +
                                            scope.$index +
                                            "." +
                                            val.key,
                                          rules: [
                                            {
                                              required: true,
                                              message: "不能为空",
                                              trigger: "blur",
                                            },
                                          ],
                                        },
                                      },
                                      [
                                        _c("el-input", {
                                          attrs: {
                                            disabled:
                                              index == 0 || _vm.status != "new",
                                          },
                                          model: {
                                            value: scope.row[val.key],
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, val.key, $$v)
                                            },
                                            expression: "scope.row[val.key]",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.emplFlag == "SUP"
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("capacity.uploadConfirmSup"))),
                  ]),
                ]
              ),
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.fileList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "documentName",
                      label: _vm.$t("common.template"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadFile(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.documentName) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1787077931
                    ),
                  }),
                ],
                1
              ),
              _vm.supFileBtnShow
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticStyle: { float: "left" },
                      attrs: {
                        action: "upload",
                        "http-request": _vm.uploadConfirmSup,
                        "show-file-list": false,
                        multiple: "",
                        name: "spFile",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            type: "primary",
                          },
                          slot: "trigger",
                        },
                        [_vm._v(_vm._s(_vm.$t("common.selectFile")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.supFileList,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "documentName",
                      label: _vm.$t("common.file"),
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.downloadFile(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.documentName) + " ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1787077931
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      prop: "tmDocumentId",
                      "min-width": "130px",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-link",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.supFileBtnShow,
                                      expression: "supFileBtnShow",
                                    },
                                  ],
                                  attrs: { type: "primary" },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.deleteFile(
                                        scope.row.tmDocumentId,
                                        scope.$index,
                                        _vm.fileList
                                      )
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("common.del")))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3601193333
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }